/*
 * @Author: Dong
 * @Date: 2022-04-12 16:29:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-18 14:09:32
 */
import request from 'root/utils/request';
import { PartitionType, DiskResizeType } from 'root/pages/DiskConfig/diskTypes';
import { UpdateHostListType } from 'root/pages/EnvManage/HostMonitor/types';

const basePath = '/api/ops-manager/v1/supos/disk';

interface PutServerDataType {
  id?: string;
  name: string;
  ip: string;
  sshPort: number;
  user: string;
  password: string;
  labels?: string[];
}

interface IDiskGetDataType {
  clientIds?: string[];
  labels?: string[];
  runtimeEnvId?: string;
}

// 获取可用磁盘列表  TODO 调用时要增加主机id
export const getAvailabledDisksApi = async (data?: IDiskGetDataType) => {
  return request({
    method: 'POST',
    url: `${basePath}/availabledisks`,
    data,
  });
};

// 获取磁盘配置 TODO 调用时要增加主机id
export const getDiskConfigApi = async (data: {
  size: number;
  vgName?: string;
  clientIds?: string[];
  labels?: string[];
  cluster: number;
}) => {
  return request({
    method: 'POST',
    url: `${basePath}/config`,
    data,
  });
};

// 添加磁盘 TODO 调用时要增加主机id
export const postAddDiskApi = async (data: {
  diskPaths: string[];
  vgPath: string;
  clientIds?: string[];
  labels?: string[];
}) => {
  return request({
    method: 'POST',
    url: `${basePath}/new`,
    data,
  });
};

// 开始分区 TODO 调用时要增加主机id
export const postPartitionApi = async (data: PartitionType) => {
  return request({
    method: 'POST',
    url: `${basePath}/partition`,
    data,
  });
};

// 挂载点与扩展磁盘 TODO 调用时要增加主机id
export const postDiskResizeApi = async (data: {
  resizeList: DiskResizeType[];
  clientIds?: string[];
  labels?: string[];
}) => {
  return request({
    method: 'POST',
    url: `${basePath}/resize`,
    data,
  });
};

// 格式化分区 TODO 调用时要增加主机id
export const postVgdeleteApi = async (params: {
  vgPath: string;
  delete: boolean;
  clientIds?: string[];
  labels?: string[];
}) => {
  return request.post(`${basePath}/vgdelete`, params);
};

// 分区状态
export const getPartitionStatusApi = async (params: { clientIds?: string[] }) => {
  return request.post(`${basePath}/partition/info`, params);
};

// 获取连接设置信息
export const getServerDataApi = async () => {
  return request.get(`/api/ops-manager/v1/server/node/list`);
};

// 设置 连接信息  PS:新增接口这期功能暂时用不到
export const postServerDataApi = async (params: PutServerDataType) => {
  return request.post(`/api/ops-manager/v1/server/node`, params);
};

// 编辑链接
export const putServerDataApi = async (params: PutServerDataType) => {
  return request.put(`/api/ops-manager/v1/server/node`, params);
};

// 测试链接
export const linkServerApi = async (id: string) => {
  return request.get(`/api/ops-manager/v1/server/node/connect/validation?id=${id}`);
};

// 获取是否存在节点
export const checkHostStatusApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/runtime_env/deploy`);
};

// 获取节点详情id
export const getHostDetailApi = async (params: UpdateHostListType) => {
  return request.post(`/api/ops-manager/v1/server/node/brief/list`, params);
};

// 添加单个节点
export const postHostDataApi = async (params: any) => {
  return request.post(`/api/ops-manager/v1/server/node`, params);
};

// 檢查節點链接状态
export const checkNodeStatusApi = async (params: { serverNodeId: string }) => {
  return request.get(`/api/ops-manager/v1/server/node/health`, { params: { ...params } });
};

// 批量添加主机节点
export const postHostBatchApi = async (params: { file: any }) => {
  return request.post(`/api/ops-manager/v1/server/node/excel/batch`, params);
};

// 检测主机节点是否被占用
export const checkhHost = async (params: any) => {
  return request.post(`/api/ops-manager/v1/server/node/agent`, params);
};

// 获取主机详情中主机基础信息
export const getHostBasicDataApi = async (params: IDiskGetDataType) => {
  return request.post(`/api/ops-manager/v1/server/node/basic`, params);
};

// 获取主机详情中主机基础信息(不依赖agent信息部分)
export const getHostResourceApi = async (params: IDiskGetDataType) => {
  return request.post(`/api/ops-manager/v1/server/node/resource`, params);
};

// 获取主机的系统时间
export const getHostTimeApi = (params: IDiskGetDataType) => {
  return request.post(`/api/ops-manager/v1/server/node/time/info`, params);
};

// 同步系统时间
export const postSyncTimeApi = async (params: IDiskGetDataType) => {
  return request.post(`/api/ops-manager/v1/server/node/time/sync`, params);
};

// 批量上传节点
export const importNodeApi = async (params: { file: any }) => {
  return request.post(`/api/ops-manager/v1/server/node/excel/upload`, params);
};

// 删除主机节点
export const deleteNodeApi = async (data: string[]) => {
  return request({
    method: 'delete',
    url: `/api/ops-manager/v1/server/node`,
    data,
  });
};

// 将excel表格数据导入
export const getImportedNodeApi = async () => {
  return request.get(`/api/ops-manager/v1/server/node/excel/import`);
};

// 获取标签
export const getLabelApi = async (params?: { id?: string; label?: string }) => {
  return request.get(`/api/ops-manager/v1/supos/labels/query`, { params: { ...params } });
};

// 下载配置模板
export const exportExcelDownloadApi = async () => {
  return request.get(`/api/ops-manager/v1/server/node/excel/download`, {
    responseType: 'blob',
  });
};

// 上传失败下载源文件
export const exportErrorExcelApi = async (path: string) => {
  return request.get(`/api/ops-manager/v1/server/node/error/excel/download?path=${path}`, {
    responseType: 'blob',
  });
};

// 获取当前服务器卷组列表信息
export const getVginfo = async (params: IDiskGetDataType) => {
  return request.post(`/api/ops-manager/v1/supos/disk/ops/vginfo`, params);
};
